/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for data grouped by site type.
 * @export
 * @interface GroupedBySiteType
 */
export interface GroupedBySiteType {
    /**
     * 
     * @type {string}
     * @memberof GroupedBySiteType
     */
    siteType: string;
    /**
     * 
     * @type {number}
     * @memberof GroupedBySiteType
     */
    count: number;
}

/**
 * Check if a given object implements the GroupedBySiteType interface.
 */
export function instanceOfGroupedBySiteType(value: object): value is GroupedBySiteType {
    if ((!('siteType' in (value as Record<string, any>)) && !('site_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['siteType'] === undefined && (value as Record<string, any>)['site_type'] === undefined)) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function GroupedBySiteTypeFromJSON(json: any): GroupedBySiteType {
    return GroupedBySiteTypeFromJSONTyped(json, false);
}

export function GroupedBySiteTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupedBySiteType {
    if (json == null) {
        return json;
    }
    return {
        
        'siteType': json['site_type'],
        'count': json['count'],
    };
}

export function GroupedBySiteTypeToJSON(json: any): GroupedBySiteType {
    return GroupedBySiteTypeToJSONTyped(json, false);
}

export function GroupedBySiteTypeToJSONTyped(value?: GroupedBySiteType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site_type': value['siteType'],
        'count': value['count'],
    };
}

